import React from "react";
import { cache } from "@emotion/css";
import { serializeStyles } from "@emotion/serialize";
import { registerStyles, insertStyles } from "@emotion/utils";
const isServer = typeof window === "undefined";
const useInsertionEffectSpecifier = "useInsertionEffect";
const useInsertionEffect = React[useInsertionEffectSpecifier] ?? React.useLayoutEffect;
function useStyle(style) {
  const serialized = serializeStyles([style], cache.registered);
  registerStyles(cache, serialized, false);
  useInsertionEffect(() => {
    insertStyles(cache, serialized, false);
  });
  if (isServer)
    insertStyles(cache, serialized, false);
  return `${cache.key}-${serialized.name}`;
}
export {
  useStyle
};
//# sourceMappingURL=use-style.js.map